export default __webpack_public_path__ + "859de7a6e523a92e165faa5dbbc8c40d.png";